import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import TransactionReasons from 'components/Admin/TransactionReasons';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <TransactionReasons />
      </SiteContent>
    </ContentLayout>
  );
};
